import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from '../ui/card';
import {
  AlertTriangle, FileCheck, Files, PauseCircle, Receipt, Clock,
  AlertCircle, ChevronRight, CheckCircle,
} from 'lucide-react';

const iconMap = {
  'file-check': FileCheck,
  files: Files,
  'pause-circle': PauseCircle,
  receipt: Receipt,
  clock: Clock,
  'alert-circle': AlertCircle,
};

const Block = ({ item }) => {
  const Icon = iconMap[item.icon] || AlertCircle;
  const isZero = !item.count || item.count === 0;
  const inner = (
    <div
      className={`flex items-center justify-between gap-3 rounded-lg border px-3 py-2.5 transition-colors ${
        isZero ? 'border-[#EDEDED] bg-gray-50/60 opacity-60' : 'border-orange-200 bg-orange-50/60 hover:bg-orange-50 cursor-pointer'
      }`}
      data-testid={`attention-block-${item.id}`}
    >
      <div className="flex items-center gap-2.5 min-w-0">
        <div className={`w-8 h-8 rounded-lg flex items-center justify-center shrink-0 ${isZero ? 'bg-gray-100' : 'bg-orange-100'}`}>
          <Icon className={`w-4 h-4 ${isZero ? 'text-gray-400' : 'text-orange-600'}`} />
        </div>
        <span className="text-sm text-gray-700 leading-snug truncate">{item.label}</span>
      </div>
      <div className="flex items-center gap-1.5 shrink-0">
        <span className={`text-lg font-bold ${isZero ? 'text-gray-400' : 'text-[#C0392B]'}`}>{item.count || 0}</span>
        {!isZero && <ChevronRight className="w-4 h-4 text-orange-300" />}
      </div>
    </div>
  );
  if (isZero || !item.link) return inner;
  return <Link to={item.link} className="block no-underline text-inherit">{inner}</Link>;
};

export const VerificheAnomalieBar = ({ groups = [] }) => {
  const items = groups.flatMap((g) => g.items || []);
  const totalActive = items.reduce((s, i) => s + (i.count || 0), 0);

  return (
    <Card className="bg-white rounded-xl border border-[#E4E4E4] shadow-sm" data-testid="direzione-attention">
      <CardContent className="py-3.5">
        <div className="flex flex-col sm:flex-row sm:items-center gap-3">
          <div className="flex items-center gap-2 shrink-0 sm:min-w-[200px]">
            <AlertTriangle className="w-5 h-5 text-[#FF7819]" />
            <span className="text-base font-semibold text-gray-900">Verifiche e anomalie</span>
          </div>
          {totalActive === 0 ? (
            <div className="flex items-center gap-2 text-sm font-medium text-gray-500 sm:ml-auto" data-testid="attention-zero">
              <CheckCircle className="w-4 h-4 text-green-500" />
              Nessuna verifica urgente
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2.5 flex-1">
              {items.map((item) => <Block key={item.id} item={item} />)}
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};
